export const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png", "application/pdf"]; 
export const MAX_FILE_SIZE = 5942880; // 5*1024*1024 bytes

export const REQUIRED_FIELD_PATH = 'required';
export const HOUSE_NUM_INVALID_PATH = 'invalid-house-number';
export const APPARTMENT_NUM_INVALID_PATH = 'invalid-appartment-number';
export const STREET_NOT_SELECTED_PATH = 'street-not-selected';
export const INVALID_EMAIL_PATH = 'invalid-email';
export const MOBILE_FORMAT_PATH = 'mobile-number';
export const PERSON_ID_INVALID_PATH = 'person-id-invalid';
export const ONLY_DIGIT_PERMITED_PATH = 'only-digits-allowed';
export const ONLY_DIGIT_AND_DASHES_PERMITED_PATH = 'only-digits-allowed-and-dashes';
export const ONLY_LETTERS_HEBREW_OR_ENGLISH_PERMITED_PATH = 'only-english-and-hebrew-and-spaces';
export const ONLY_LETTERS_ENGLISH_PERMITED_PATH = 'only-english-and-spaces';
export const FILE_TOO_LARGE_PATH = 'file.too-large';
export const FILE_UNSUPPORTED_FORMAT_PATH = 'file.unsupported-format';

